import { IFirstHandReport, IResortPathInfo } from 'api/resort/types';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { NextLinkTr } from 'components/blocks/NextLink';
import { Routes } from 'routes';
import { Report } from 'components/resort/Report';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import styles from './styles.module.scss';

export const ResortLastHandReport = ({ resort, firstHand }:{ resort: IResortPathInfo, firstHand: IFirstHandReport }) => {
  const { t } = useOTSTranslation('common');

  return (
    <BoxWithShadow>
      <BlockHeader useH3 title={t('resort.skiReport.firstHandReport')}>
        <NextLinkTr href={Routes.resortFHReports(resort)} data-click-id="resort-report-fhreports">
          {t('resort.skiReport.allFirstHandReports')}
        </NextLinkTr>
      </BlockHeader>
      <BlockContent>
        <Report report={firstHand} className={styles.firstHandRpt} />
      </BlockContent>
    </BoxWithShadow>
  );
};
